export class Inquiry {
    public name: string = ""
    public company_name: string = ""
    public contact_mail: string = ""
    public content: string = ""
}